import TemporaryBloodPressureHackedGraph from './TemporaryBloodPressureHackedGraph'

export default TemporaryBloodPressureHackedGraph
